import { render, staticRenderFns } from "./MessageTask.vue?vue&type=template&id=2d5b3039&scoped=true"
import script from "./MessageTask.vue?vue&type=script&lang=js"
export * from "./MessageTask.vue?vue&type=script&lang=js"
import style0 from "./MessageTask.vue?vue&type=style&index=0&id=2d5b3039&prod&lang=scss&scoped=true"
import style1 from "./MessageTask.vue?vue&type=style&index=1&id=2d5b3039&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5b3039",
  null
  
)

export default component.exports